import React from "react";
import { createUseStyles } from "react-jss";
import DisplayText, { TextVariant } from "./DisplayText";
var useStyles = createUseStyles(function (theme) { return ({
    welcome: {
        color: theme.welcome.welcomeText.color,
        marginBottom: 16,
    },
    mainTitle: {
        marginBottom: 12,
    },
    subtitle: {
        color: theme.welcome.subtitle.color
    }
}); });
var Welcome = function (_a) {
    var title = _a.title, children = _a.children;
    var classes = useStyles();
    if (!children) {
        children = React.createElement(React.Fragment, null, "Created by Solutions Experiences");
    }
    return (React.createElement("div", null,
        React.createElement(DisplayText, { className: classes.welcome, variant: TextVariant.welcome, align: "center" }, "Welcome!"),
        React.createElement(DisplayText, { className: classes.mainTitle, variant: TextVariant.title, color: "white", align: "center" }, title !== null && title !== void 0 ? title : "Engage App"),
        React.createElement(DisplayText, { className: classes.subtitle, variant: TextVariant.s34reg, align: "center" }, children)));
};
export default Welcome;
//# sourceMappingURL=Welcome.js.map